import { render, staticRenderFns } from "./ModalPoint.vue?vue&type=template&id=2fd3120b&scoped=true"
import script from "./ModalPoint.vue?vue&type=script&lang=js"
export * from "./ModalPoint.vue?vue&type=script&lang=js"
import style0 from "./ModalPoint.vue?vue&type=style&index=0&id=2fd3120b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd3120b",
  null
  
)

export default component.exports